interface GtmProps {
  processStepName?: string;
  processStepValue?: string;
  processName?: string;
}

const gtm = {
  event(eventName: string, props?: GtmProps) {
    window.dataLayer?.push({ event: eventName, ...props });
  },
};

export default gtm;
